import { proxy } from 'valtio'
import { useQuery } from 'react-query'
import { CommonApi, Option } from '../../generated'
import { apiConfig } from '../apiConfig'
import { Lang } from '../i18n/useLang'
import { getName } from '../util/getName'
import { convertProgramType, ProgramType } from '../ProgramType'

export const programTypesStore = proxy<{ items: Option[] }>({
  items: [],
})

new CommonApi(apiConfig).getProgramTypes().then((result) => {
  programTypesStore.items = result
})

const api = new CommonApi(apiConfig)

export async function loadProgramTypes() {
  await api.getProgramTypes().then((result) => {
    programTypesStore.items = result
  })
}

export function useProgramTypes()  {
  return useQuery('program-types', loadProgramTypes)
}

// getId from ProgramType.ts
export function getIdFromProgramType(programType: ProgramType): number | undefined {
  if (!programType) return undefined
  const item = programTypesStore.items.find((i) => convertProgramType(i) === programType)
  return item ? item.id : undefined
}